var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser1Bold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.944 18.288C22.1831 16.7689 19.6871 15.8527 16.2325 14.5807L15.3459 14.256C15.2399 14.1315 15.1723 13.979 15.1511 13.8169C15.0206 13.2083 15.0488 12.5763 15.2329 11.9816C15.9842 11.1673 16.5564 10.2047 16.9129 9.1557C17.2694 8.10673 17.4021 6.9947 17.3026 5.89129C17.3026 2.47906 15.0734 0 12 0C8.92659 0 6.69741 2.47906 6.69741 5.89271C6.59675 6.99147 6.72699 8.09914 7.07977 9.1446C7.43255 10.19 8.00007 11.1502 8.74588 11.9633C8.94908 12.5616 8.98472 13.2041 8.84894 13.8212C8.8273 13.9815 8.76129 14.1326 8.65835 14.2574L7.76471 14.5807C4.31012 15.8513 1.81412 16.7689 1.05318 18.288C0.372735 19.8701 0.0146921 21.572 0 23.2941C0 23.4813 0.0743697 23.6609 0.206748 23.7933C0.339127 23.9256 0.518671 24 0.705882 24H23.2941C23.4813 24 23.6609 23.9256 23.7933 23.7933C23.9256 23.6609 24 23.4813 24 23.2941C23.9844 21.5718 23.6254 19.8699 22.944 18.288Z",
    stroke: "none",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser1Bold);
export default __webpack_public_path__ + "static/media/user1-bold.53edef4e97ceee7e66cefcac35a998ed.svg";
export { ForwardRef as ReactComponent };